export URL_PATH,{ URL } from './routes';

export const REQUEST_METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};
export const ACTION = {
    GET_LANG_SUCCESS: 'GET_LANG_SUCCESS',
    GET_MENU_SUCCESS: 'GET_MENU_SUCCESS',
    SHOW_MAIN_LOADER: 'SHOW_MAIN_LOADER',
    HIDE_MAIN_LOADER: 'HIDE_MAIN_LOADER',
    ADD_META_DATA:'ADD_META_DATA',
    SHOW_NAV_MENU: 'SHOW_NAV_MENU',
    HIDE_NAV_MENU: 'HIDE_NAV_MENU',
    SAVE_CART_DETAILS: 'SAVE_CART_DETAILS',
    GET_PROMOTIONAL_HEADER: 'GET_PROMOTIONAL_HEADER'
};

export const LANGUAGE={
    EN:'en',
    HI:'hi',
};

export const UPPER_CASE_BREAD_CRUMB = [
    'MBA', 'HDFC', 'AMC', 'SIP'
]